import type { FilterConditionDto } from './condition';
import { BdCondition } from './condition';

export abstract class BdRangeCondition<T> extends BdCondition {
  protected constructor(
    id: string,
    public from: T | null = null,
    public to: T | null = null,
  ) {
    super(id);
  }

  toJSON(): FilterConditionDto {
    return {
      [this.id]: {
        from: this.from,
        to: this.to,
      },
    };
  }
}
